<script lang="ts">
	import type { ButtonSVGType } from '../types';
	import Button from '../Button.svelte';
	import SVG from '$lib/elements/SVG.svelte';

	export let props: ButtonSVGType;

	$: size = (props && props.size) || 'default';
</script>

{#if props && props.name}
	<Button {...$$restProps} {props} on:click>
		<SVG
			name={props.name}
			size={props.size ? props.size : size}
			classNames={props.iconClassNames}
		/>
	</Button>
{/if}
